'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index_js = require('../utils/index.js');
var prosemirrorState = require('prosemirror-state');
var index_js$1 = require('../cursor/index.js');
var prosemirrorModel = require('prosemirror-model');
var preact = require('preact');
var index_js$2 = require('../components/index.js');

var schema = {
  nodes: {
    link: {
      inline: true,
      attrs: {
        id: {
          default: ""
        },
        href: {
          default: ""
        },
        title: {
          default: ""
        },
        pageId: {
          default: ""
        },
        autoUpdate: {
          default: ""
        },
        isNew: {
          default: false
        }
      },
      group: "inline",
      content: "text*",
      defining: true,
      parseDOM: [{
        tag: "a[href]",

        getAttrs(dom) {
          return {
            id: index_js.uuid(),
            href: dom.getAttribute("href"),
            title: dom.innerText,
            pageId: dom.getAttribute("data-pageid"),
            autoUpdate: dom.getAttribute("data-auto_update") === "1",
            isNew: false
          };
        }

      }],

      toDOM(node) {
        const {
          href,
          pageId,
          autoUpdate
        } = node.attrs;
        const attrs = {
          class: "ct-link",
          href,
          "data-pageid": pageId,
          "data-auto_update": autoUpdate ? "1" : "0"
        };
        return ["a", attrs, 0];
      }

    }
  }
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var objectSpread = _objectSpread;

function addLink(attrs, outSelection) {
  return function (state, dispatch) {
    const {
      tr,
      schema
    } = state;
    const nodeType = schema.nodes.link;
    const selection = outSelection || state.selection;
    let {
      $cursor,
      $from,
      $to,
      from,
      to
    } = selection;

    if (selection instanceof index_js$1.GapCursor) {
      $cursor = $from;
    }

    const text = attrs.title || attrs.href;

    if ($cursor && !outSelection) {
      const node = $cursor.nodeBefore || $cursor.nodeAfter || {
        marks: []
      };
      const marks = node.marks;
      let plus = 1;

      if (selection instanceof index_js$1.GapCursor) {
        plus = 2;
      }

      tr.insert($cursor.pos, nodeType.create(attrs, schema.text(text), marks));

      if (!attrs.autoUpdate) {
        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, $cursor.pos + text.length + plus));
      }

      dispatch(tr.scrollIntoView());
    } else {
      const node = $from.nodeAfter || $to.nodeBefore || $from.nodeBefore || $to.nodeAfter || {
        marks: []
      };
      const marks = node.marks;
      const plus = 1; // if ($from.parentOffset === 0) plus = 2

      tr.replaceWith(from - ($from.nodeBefore ? 0 : 1), to, nodeType.create(attrs, schema.text(text), marks));

      if (!attrs.autoUpdate) {
        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + text.length + plus));
      }

      dispatch(tr.scrollIntoView());
    }
  };
} // :: (state: EditorState, dispatch: ?(tr: Transaction)) → null

function cancelLink() {
  return function (state, dispatch, view) {
    const {
      tr,
      schema,
      selection
    } = state;
    const {
      $from
    } = selection;
    const node = selection instanceof prosemirrorState.NodeSelection ? selection.node : $from.parent;

    if (node.type.name !== "link") {
      return false;
    }

    const from = $from.start($from.depth);
    const to = from + node.nodeSize - 1;
    let text = node.textContent;

    if (selection instanceof prosemirrorState.NodeSelection) {
      const dom = view.nodeDOM(from);
      text = dom.textContent;
    }

    if (selection instanceof prosemirrorState.NodeSelection) {
      dispatch(tr.replaceSelectionWith(schema.text(text)));
    } else {
      dispatch(tr.replaceWith(from - 1, to, schema.text(text)));
    }
  };
} // :: (state: EditorState) → bool

function hasLink(state) {
  if (!state) {
    return false;
  }

  const {
    tr,
    schema
  } = state;
  const nodeType = schema.nodes.link;
  const selection = state.selection;
  const {
    from,
    to
  } = selection;
  let has = false;
  tr.doc.nodesBetween(from, to, node => {
    if (nodeType === node.type) {
      has = true;
    }

    return !has;
  });
  return has;
} // :: (state: EditorState) → attrs: Object

function getLinkAttrs(state, dispatch, outSelection) {
  if (!state) {
    return null;
  }

  let attrs = {};
  const {
    tr,
    doc,
    schema
  } = state;
  const nodeType = schema.nodes.link;
  const selection = outSelection || state.selection;
  const {
    $from,
    from,
    to
  } = selection;
  let linkNode = null;
  let linkNodeFrom = null;
  tr.doc.nodesBetween(from, to, (node, pos) => {
    if (nodeType === node.type) {
      linkNode = node;
      linkNodeFrom = pos;
      attrs = objectSpread({}, node.attrs, {
        title: linkNode.textContent
      });
      tr.setNodeMarkup(pos, null, attrs);
    }
  });

  if (linkNode) {
    if (dispatch) {
      dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, linkNodeFrom, linkNodeFrom + linkNode.nodeSize)));
    }
  } else if (attrs.href) {
    const textNode = $from.node();

    if (dispatch) {
      dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from, from + textNode.nodeSize)));
    }

    attrs.title = textNode.textContent;
  } else {
    attrs.title = doc.textBetween(from, to);
  }

  return attrs;
}

const CLASS_NAME = "ct-link";
const AUTO_UPDATE_CLASS_NAME = `${CLASS_NAME} ${CLASS_NAME}-auto-update`;
const regex1 = /^(https?:\/\/)?(\w+\.?)+(\/.+)?$/i;
const regex2 = /^((https?:\/\/|\w+(\.\w+)+)(:\w+)?).+$/;
const regex3 = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

class LinkView {
  constructor(node, view, getPos, store) {
    this.dom = void 0;
    this.contentDOM = void 0;
    this.node = void 0;
    this.view = void 0;
    this.getPos = void 0;
    this.store = void 0;

    this.destroy = () => {
      this.dom.removeEventListener("click", this.handleClick);
    };

    this.handleClick = e => {
      e.preventDefault();

      if (this.node.attrs.autoUpdate) {
        const {
          dispatch,
          state: {
            doc,
            tr
          }
        } = this.view;
        const newSelection = prosemirrorState.NodeSelection.create(doc, this.getPos());
        dispatch(tr.setSelection(newSelection));
      }
    };

    this.setTitle = async () => {
      const {
        pageId,
        id: cacheKey,
        autoUpdate,
        href
      } = this.node.attrs;
      let docId = pageId;

      try {
        if (!docId && autoUpdate) {
          // 补救脏数据,已产生的空id，重新获取一次
          const data = await this.store.checkPageTitle(href);
          docId = data ? data.pageId : "";
        }

        if (!docId) {
          // 仍然找不到id，直接以href展示链接内容，而非上次的错误的title展示
          this.dom.innerText = href;
          return;
        }

        const res = await this.store.getTitleByPageId(docId, cacheKey);

        if (res && res.length && res[0]) {
          this.dom.innerText = res[0];
        } else {
          this.dom.innerText = this.node.attrs.title;
        }
      } catch (e) {
        this.dom.innerText = this.node.attrs.title;
      }

      if (this.store.editor.catalogStore && this.store.editor.catalogStore.update) {
        this.store.editor.catalogStore.update();
      }
    };

    this.initPageIdAndAutoUpdate = async () => {
      const {
        href,
        id
      } = this.node.attrs;

      const attrs = objectSpread({}, this.node.attrs, {
        isNew: false
      });

      const res = await this.store.checkPageTitle(href);
      Object.assign(attrs, {
        pageId: res ? res.pageId : "",
        autoUpdate: !!res,
        id: id || index_js.uuid()
      });
      const {
        dispatch,
        state: {
          tr
        }
      } = this.view;

      try {
        dispatch(tr.setNodeMarkup(this.getPos(), undefined, attrs));
      } catch (e) {
        // 打印错误，但不上报 sentry
        console.error(e);
      }
    };

    const {
      href: _href,
      title,
      autoUpdate: _autoUpdate,
      isNew
    } = node.attrs;
    const _attrs = {
      href: _href,
      target: "_blank",
      rel: "noopener",
      innerText: title,
      className: _autoUpdate ? AUTO_UPDATE_CLASS_NAME : CLASS_NAME
    };
    this.node = node;
    this.view = view;
    this.getPos = getPos;
    this.store = store;
    this.dom = document.createElement("a");
    this.dom.addEventListener("click", this.handleClick);
    Object.assign(this.dom, _attrs);

    if (isNew) {
      this.initPageIdAndAutoUpdate();
    } else {
      if (!_autoUpdate) {
        this.contentDOM = this.dom;
      } else {
        this.setTitle();
      }
    }
  }

}

// const mailReg = /([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+/;

const pluginKey = new prosemirrorState.PluginKey("link"); // const newReg = /((?:https?:\/\/|www\.)[-A-Za-z0-9+&@#/%=~_|.:*[\]=?,]+)/g

const createPlugin = store => new prosemirrorState.Plugin({
  key: pluginKey,
  props: {
    handleDOMEvents: {
      keydown: (view, event) => {
        if (event.key !== 'Enter') {
          return false;
        }

        const state = view.state;
        const dispatch = view.dispatch;
        const {
          tr,
          schema,
          selection
        } = state;
        const {
          $from
        } = selection;
        const link = schema.nodes.link;
        const foundNode = index_js.findParentNode($from.path, node => node.type === link);

        if (foundNode) {
          const {
            node,
            pos
          } = foundNode;
          const newSelection = prosemirrorState.TextSelection.create(tr.doc, pos + node.nodeSize);
          dispatch(tr.setSelection(newSelection));
          view.focus();
          return true;
        }

        return false;
      }
    },
    handleClick: (view, pos1, e) => {
      if (e.button !== 0) {
        return false;
      }

      const {
        tr,
        selection,
        schema
      } = view.state;
      const {
        link
      } = schema.nodes;
      const {
        $cursor
      } = selection;

      const assert = node => node.type === link;

      const foundNode = $cursor && index_js.findParentNode($cursor.path, assert);

      if (foundNode) {
        const pos = foundNode.pos;
        const linkDOM = view.docView.domFromPos(pos + 1).node;
        store.showPopover({
          dom: linkDOM,
          selection: tr.selection
        });
      }

      return false;
    },
    handleDoubleClick: view => {
      const {
        state,
        dispatch
      } = view;
      const {
        tr,
        selection,
        schema
      } = state;
      const {
        link
      } = schema.nodes;
      const {
        $cursor
      } = selection;

      const assert = node => node.type === link;

      const foundNode = $cursor && index_js.findParentNode($cursor.path, assert);

      if (foundNode) {
        const pos = foundNode.pos;
        const linkDOM = view.docView.domFromPos(pos + 1).node;
        dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, pos + 1, pos + foundNode.node.nodeSize)));
        store.openModal({
          href: linkDOM.href,
          title: linkDOM.innerText
        }, 1);
        return true;
      }

      return false;
    },
    handleKeyDown: () => {
      if (store.hasPopover) {
        store.hidePopover();
      }
    },
    transformPasted: slice => {
      const {
        view
      } = store;
      const {
        state
      } = view;
      const {
        schema
      } = state;
      const {
        link,
        paragraph,
        text
      } = schema.nodes;
      let allTransformCount = 0;

      const transferNode = function (node) {
        const textContent = node.textContent;
        let urlReg = /((https?:\/\/|www\.)[-A-Za-z0-9+&@#/%=~_|.:*[\]=?,]+)/g;
        let mailReg = /([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+/g;
        let attrs = null;

        if (urlReg.test(textContent)) {
          attrs = {
            href: textContent,
            title: textContent,
            autoUpdate: true,
            isNew: true
          };
        }

        if (mailReg.test(textContent)) {
          attrs = {
            href: `mailto:${textContent}`,
            title: textContent,
            autoUpdate: true,
            isNew: true
          };
        }

        if (attrs) {
          node.type === text ? allTransformCount += 2 : void 0; // 添加标签后nodesize + 2

          return link.create(attrs, schema.text(textContent), node.marks);
        }

        return node;
      };

      slice.content.content = slice.content.content.map(node => {
        // let urlReg = /((https?:\/\/|www\.)[-A-Za-z0-9+&@#/%=~_|.:*[\]=?,]+)/g;
        if (node.type === link || node.type === text) {
          return transferNode(node);
        }

        if (node.type === paragraph) {
          let transformCount = 0;
          let newNodeList = [];
          node.content.content.map((textNode, index) => {
            const newReg = /((?:https?:\/\/|www\.)[-A-Za-z0-9+&@#/%=~_|.:*[\]=?,]+)/g;
            const newMailReg = /((?:[a-zA-Z0-9_.-])+@(?:(?:[a-zA-Z0-9-])+\.)+(?:[a-zA-Z0-9]{2,4}))+/g;
            const textContent = textNode.textContent;
            const needTransferUrl = textNode.type === text && newReg.test(textContent);
            const needTransferMail = textNode.type === text && newMailReg.test(textContent);

            if (needTransferUrl || needTransferMail) {
              // todo mailReg
              const splitReg = needTransferUrl ? newReg : newMailReg;
              let textArr = textContent.split(splitReg).filter(item => {
                return item !== '';
              });
              let nodeArr = textArr.map(innerText => {
                let newLinkNode = transferNode(schema.text(innerText));
                if (newLinkNode.type !== text) transformCount += 2;
                return newLinkNode;
              });
              newNodeList = newNodeList.concat(nodeArr);
            } else {
              newNodeList.push(textNode);
            }
          });
          node.content.size += transformCount; // todo size
          // allTransformCount += transformCount;

          return node.copy(prosemirrorModel.Fragment.from(newNodeList));
        }

        return node;
      });
      slice.content.size += allTransformCount;
      return slice;
    },
    nodeViews: {
      link: (node, view, getPos) => new LinkView(node, view, getPos, store)
    }
  },
  view: view => new index_js.Popover({
    view,
    store,
    className: "ct-link-popover",
    sticky: false
  })
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".ct-link-editor .menu-item{position:relative;display:inline-block;width:36px;height:38px}.ct-link-editor .menu-item:hover{background-color:#f6f6f6!important}.ct-link-editor .menu-item.cancel{background:url(../assets/cancelLink.svg) no-repeat 50%}.ct-link-editor .menu-item.edit{background:url(../assets/editLink.svg) no-repeat 50%}.ct-link-editor .menu-item.visit{background:url(../assets/visitLink.svg) no-repeat 50%}";
styleInject(css);

/** @jsx h */

class LinkEditor extends preact.Component {
  constructor(...args) {
    super(...args);

    this.onGlobalClick = e => {
      const {
        hidePopover
      } = this.props;
      const targetDOM = e.target;

      if (!targetDOM.closest(".ct-link")) {
        hidePopover();
      }
    };
  }

  componentDidMount() {
    document.addEventListener("click", this.onGlobalClick);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.onGlobalClick);
  }

  render() {
    const {
      cancelLink,
      visitLink,
      editLink
    } = this.props;
    return preact.h("div", {
      className: "ct-link-editor"
    }, preact.h(index_js$2.IconItem, {
      tip: "\u53D6\u6D88\u94FE\u63A5",
      onClick: cancelLink,
      type: "cancelLink"
    }), preact.h(index_js$2.IconItem, {
      tip: "\u8BBF\u95EE\u94FE\u63A5",
      onClick: visitLink,
      type: "visitLink"
    }), preact.h(index_js$2.IconItem, {
      tip: "\u7F16\u8F91\u94FE\u63A5",
      onClick: editLink,
      type: "edit"
    }));
  }

}

const formatLink = href => {
  const newHref = href.split("mailto:").reverse()[0].replace(regex1, (match, capture) => capture ? match : `http://${match}`);

  if (regex2.test(newHref) || newHref.indexOf("http") === 0) {
    return newHref;
  }

  if (regex3.test(newHref)) {
    return `mailto:${newHref}`;
  }

  return false;
};

var css$1 = ".ct-link-modal{padding:24px;font-size:12px}.ct-link-modal .cte-link-modal-item{color:rgba(0,0,0,.6);line-heigt:22px}.ct-link-modal .cte-link-modal-item>label{display:flex;align-items:center}.ct-link-modal .cte-link-modal-item>label span{width:60px}.ct-link-modal .cte-link-modal-item:not(:last-child){margin-bottom:16px}.ct-link-modal .cte-link-modal-item input[type=text]{width:100%;height:32px;padding:6px 8px;margin-left:12px;border-radius:4px;border:1px solid rgba(0,0,0,.13);outline:none;color:rgba(0,0,0,.87);transition:all .218s ease}.ct-link-modal .cte-link-modal-item input[type=text]:focus{border:1px solid #1c6cdc}.ct-link-modal .cte-link-modal-item input[type=text]::-webkit-input-placeholder{color:rgba(0,0,0,.24)}.ct-link-modal .cte-link-modal-item input[type=text]::-moz-placeholder{color:rgba(0,0,0,.24)}.ct-link-modal .cte-link-modal-item input[type=text]::-ms-input-placeholder{color:rgba(0,0,0,.24)}.ct-link-modal .cte-link-modal-item input[type=text]:-ms-input-placeholder{color:rgba(0,0,0,.24)}.ct-link-modal .cte-link-modal-item input[type=text]::placeholder{color:rgba(0,0,0,.24)}.ct-link-modal .input-link-href{margin-bottom:24px}.ct-link-modal .error-notice{position:absolute;top:145px;left:88px;font-size:12px;color:#f05e50}.ct-link-modal .input-link-checkbox{display:flex;margin:12px 0 0 64px;cursor:pointer}";
styleInject(css$1);

class LinkModal extends preact.Component {
  constructor(props) {
    super(props);
    this.first = true;
    this.timer = null;
    this.needCheckPageTitle = false;
    this.cancelAutoUpdate = void 0;
    this.hrefInputRef = void 0;
    this.titleInputRef = void 0;

    this.handleInputHref = e => {
      const href = e.target.value.replace(/(^[\u200B\s])|([\u200B\s]$)/g, "");
      this.setState({
        href,
        pageId: null,
        error: null
      });
      this.needCheckPageTitle = true;

      if (this.state.autoUpdate) {
        this.setState({
          disabledOk: true
        });
      }

      if (this.timer !== null) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        this.checkPageTitle(href);
      }, this.first ? 0 : 300);
      this.first = false;
    };

    this.handleInputHrefBlur = () => {
      if (!this.needCheckPageTitle) {
        return;
      }

      if (this.timer !== null) {
        clearTimeout(this.timer);
      }

      const {
        href
      } = this.state;
      this.first = true;
      this.checkPageTitle(href);
    };

    this.handleInputText = e => {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }

      const title = e.target.value;
      this.setState({
        title,
        hadEdit: true,
        autoUpdate: false
      });
    };

    this.handleInputAutoUpdate = () => {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }

      const autoUpdate = !this.state.autoUpdate;
      this.setState({
        autoUpdate
      });
      this.cancelAutoUpdate = !autoUpdate;

      if (autoUpdate) {
        this.setState({
          hadEdit: false,
          disabledOk: true
        });
        this.checkPageTitle(this.state.href);
      }
    };

    this.checkPageTitle = async href => {
      const {
        checkPageTitle
      } = this.props;
      const {
        hadEdit
      } = this.state;
      const res = await checkPageTitle(href);
      this.setState({
        showAutoUpdate: !!res,
        disabledOk: false
      });
      this.needCheckPageTitle = false;

      if (hadEdit || this.cancelAutoUpdate) {
        return;
      }

      if (res) {
        const {
          title,
          pageId
        } = res;

        if (Array.isArray(title)) {
          this.setState({
            title: title[0],
            pageId,
            autoUpdate: true
          });
        }
      } else {
        this.setState({
          autoUpdate: false
        });
      }
    };

    this.handleOk = () => {
      const {
        addLink
      } = this.props;
      const {
        href,
        title,
        pageId,
        hadEdit,
        autoUpdate
      } = this.state;
      const newHref = formatLink(href);

      if (!newHref) {
        return this.setState({
          error: "请输入正确的地址"
        });
      }

      addLink({
        href: newHref,
        title: title || href,
        pageId,
        hadEdit,
        autoUpdate
      });
      this.handleCancel();
    };

    this.handleCancel = () => {
      const {
        closeModal
      } = this.props;
      closeModal();
    };

    const {
      type,
      href: _href = "",
      title: _title,
      autoUpdate: _autoUpdate = false
    } = props;
    this.state = {
      href: _href,
      title: _title,
      autoUpdate: _autoUpdate,
      showAutoUpdate: _autoUpdate || false,
      error: null,
      pageId: null,
      hadEdit: _autoUpdate ? false : type !== 0 || !!_title,
      disabledOk: false
    };
    this.cancelAutoUpdate = type === 0 ? false : !_autoUpdate;
  }

  async componentDidMount() {
    const {
      title,
      href
    } = this.state;
    await this.checkPageTitle(href);

    if (title === "") {
      this.titleInputRef.focus();
    } else {
      this.hrefInputRef.focus();
    }
  }

  render() {
    const {
      type
    } = this.props;
    const {
      error,
      href,
      title,
      autoUpdate,
      showAutoUpdate,
      disabledOk
    } = this.state;
    const autoUpdateComponent = preact.h("div", {
      className: "input-link-checkbox ct-toolbox"
    }, preact.h(index_js$2.CheckBox, {
      checked: autoUpdate,
      onClick: this.handleInputAutoUpdate
    }, "\u94FE\u63A5\u6587\u5B57\u8DDF\u968F\u6587\u6863\u6807\u9898\u53D8\u66F4"));
    return preact.h(index_js$2.Modal, {
      into: "body",
      className: "ct-link-modal",
      title: "\u94FE\u63A5",
      okText: type === 0 ? "插 入" : "保 存",
      cancelText: "\u53D6 \u6D88",
      onOk: this.handleOk,
      onCancel: this.handleCancel,
      canEnter: true,
      disabled: !href.length
    }, preact.h("div", {
      className: "cte-link-modal-item"
    }, preact.h("label", null, preact.h("span", null, "\u94FE\u63A5\u6587\u5B57:"), preact.h("input", {
      ref: ref => this.titleInputRef = ref,
      type: "text",
      placeholder: "\u8BF7\u8F93\u5165\u94FE\u63A5\u6587\u5B57",
      value: title,
      onInput: this.handleInputText
    }))), preact.h("div", {
      className: "cte-link-modal-item"
    }, preact.h("label", null, preact.h("span", null, "\u94FE\u63A5\u5730\u5740:"), preact.h("input", {
      ref: ref => this.hrefInputRef = ref,
      type: "text",
      id: "ct-link-modal-href-input",
      placeholder: "\u8BF7\u8F93\u5165\u94FE\u63A5\u5730\u5740",
      value: href,
      onInput: this.handleInputHref,
      onBlur: this.handleInputHrefBlur,
      autocomplete: "off"
    }))), showAutoUpdate && autoUpdateComponent, error && preact.h("div", {
      className: "error-notice"
    }, error));
  }

}

/** @jsx h */
class LinkStore {
  constructor() {
    this.selection = null;
    this.node = null;
    this.modal = null;
    this.pluginName = "link";
    this.titleCache = new Map();

    this.showPopover = node => {
      if (!node) {
        return;
      }

      const {
        dom,
        selection,
        view
      } = node;
      this.node = node;
      this.ctPopover.hide();

      if (view) {
        this.selection = view.state.tr.selection;
      } else {
        this.selection = selection;
      }

      this.ctPopover.show({
        dom,
        content: this.getToolbar()
      });
    };

    this.hidePopover = () => {
      this.ctPopover.hide();
      this.node = null;
    };

    this.getToolbar = () => preact.h(LinkEditor, {
      hidePopover: this.hidePopover,
      cancelLink: this.cancelLink,
      visitLink: this.visitLink,
      editLink: this.editLink
    });

    this.checkPageTitle = async href => {
      const {
        customGetTitles,
        customGetUniqueId
      } = this.config;

      if (!customGetTitles || !customGetUniqueId) {
        return null;
      }

      const pageId = customGetUniqueId(href);

      if (pageId === null) {
        return null;
      }

      const title = await customGetTitles([pageId]);

      if (title === null) {
        return null;
      }

      return {
        title,
        pageId
      };
    };

    this.openModal = ({
      href,
      title,
      autoUpdate
    }, type, selection) => {
      if (!selection) {
        this.selection = null;
      }

      this.modal = preact.render(preact.h(LinkModal, {
        type: type,
        href: href || "",
        title: title || "",
        closeModal: this.closeModal,
        checkPageTitle: this.checkPageTitle,
        addLink: this.addLink,
        autoUpdate: autoUpdate
      }), document.body);
    };

    this.closeModal = () => {
      preact.render(null, document.body, this.modal);
      this.view.focus();
    };

    this.addLink = newAttrs => {
      const {
        state,
        dispatch
      } = this.view;
      addLink(newAttrs)(state, dispatch);
    };

    this.cancelLink = () => {
      const {
        state,
        dispatch
      } = this.view;
      cancelLink(this.selection)(state, dispatch, this.view);
      this.view.focus();
    };

    this.visitLink = () => {
      const attrs = getLinkAttrs(this.view.state, this.view.dispatch, this.selection);
      const otherWindow = window.open(attrs.href);
      otherWindow.opener = null;
    };

    this.editLink = () => {
      const attrs = getLinkAttrs(this.view.state, this.view.dispatch, this.selection);
      this.openModal(attrs, 1, true);
    };

    this.getTitleByPageId = async (pageId, cacheKey) => {
      if (pageId === "" || cacheKey === "") {
        return [];
      }

      if (this.titleCache.has(cacheKey)) {
        return this.titleCache.get(cacheKey);
      }

      const title = await this.config.customGetTitles([pageId]);

      if (title && title.length && title[0]) {
        this.titleCache.set(cacheKey, title);
      }

      return title;
    };
  }

  init(editor) {
    this.editor = editor;
    this.view = editor.view;
    this.config = editor.linkConfig;
  }

}

function getTitles(ids) {
  if (!Array.isArray(ids)) {
    ids = [ids];
  }

  return Promise.resolve(ids.map(id => `标题${id}`));
}
function getUniqueId(content) {
  if (!/^https?:\/\/km\.(it\.(dev|test|beta|st)\.)?sankuai\.com\/page\/\d+/.test(content) || !content.includes(location.host) // 在编辑器开发模式（localhost），保留解析成标题功能，用来覆盖场景
  && !location.host.includes('localhost')) return null;
  const match = content.match(/\d+/);
  if (!match || !match[0]) return null;
  return match[0];
}
const config = {
  customGetTitles: getTitles,
  customGetUniqueId: getUniqueId
};

var css$2 = ".ct-link{color:#1890ff;background:transparent;text-decoration:none;outline:none}.ct-link:hover{text-decoration:underline}";
styleInject(css$2);

class LinkModule {
  constructor() {
    this.name = "link";
    this.store = new LinkStore();
    this.schema = schema;
    this.config = config;
    this.commands = {
      addLink,
      cancelLink
    };
    this.utils = {
      getLinkAttrs,
      hasLink
    };
    this.plugins = [createPlugin(this.store)];
  }

  init(moduleManager) {
    this.store.init(moduleManager);
  }

}
LinkModule.moduleName = "link";

exports.LinkModule = LinkModule;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/link/index.js